module.exports = __webpack_public_path__ + "img/gimnasio.f3658e43.svg";